module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-72x72-d1d24f6f775135d475e9c319ce294f68.png";